module.exports = __webpack_public_path__ + "img/grand-resort-2.9b4667f7.jpg";